/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Debitornummer_3_DigitsInputs */



/**

* @param {Debitornummer_3_DigitsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const debitornummer_3_digits = /** @type {((inputs?: Debitornummer_3_DigitsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Debitornummer_3_DigitsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Die Debitorennummer muss 3 Ziffern lang sein.")
});